import { createSelector } from "reselect";

const selectTables = (state) => state.statistics;

export const selector = createSelector([selectTables], (data) => data);